/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';
import type { NumericValueWithUnitDto } from './NumericValueWithUnitDto';
import {
    NumericValueWithUnitDtoFromJSON,
    NumericValueWithUnitDtoFromJSONTyped,
    NumericValueWithUnitDtoToJSON,
} from './NumericValueWithUnitDto';

/**
 * 
 * @export
 * @interface CreateNumericDataSetFilterDto
 */
export interface CreateNumericDataSetFilterDto {
    /**
     * 
     * @type {string}
     * @memberof CreateNumericDataSetFilterDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateNumericDataSetFilterDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof CreateNumericDataSetFilterDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {Array<NumericValueWithUnitDto>}
     * @memberof CreateNumericDataSetFilterDto
     */
    selectedValues?: Array<NumericValueWithUnitDto> | null;
    /**
     * 
     * @type {Array<NumericValueWithUnitDto>}
     * @memberof CreateNumericDataSetFilterDto
     */
    availableValues?: Array<NumericValueWithUnitDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateNumericDataSetFilterDto
     */
    $type?: CreateNumericDataSetFilterDtoTypeEnum;
}


/**
 * @export
 */
export const CreateNumericDataSetFilterDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoCreateNumericDataSetFilterDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.CreateNumericDataSetFilterDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateNumericDataSetFilterDtoTypeEnum = typeof CreateNumericDataSetFilterDtoTypeEnum[keyof typeof CreateNumericDataSetFilterDtoTypeEnum];


/**
 * Check if a given object implements the CreateNumericDataSetFilterDto interface.
 */
export function instanceOfCreateNumericDataSetFilterDto(value?: unknown): value is CreateNumericDataSetFilterDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateNumericDataSetFilterDtoTypeEnum)[0];
}

export function CreateNumericDataSetFilterDtoFromJSON(json: any): CreateNumericDataSetFilterDto {
    return CreateNumericDataSetFilterDtoFromJSONTyped(json, false);
}

export function CreateNumericDataSetFilterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNumericDataSetFilterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'geometry': !exists(json, 'geometry') ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        'selectedValues': !exists(json, 'selectedValues') ? undefined : (json['selectedValues'] === null ? null : (json['selectedValues'] as Array<any>).map(NumericValueWithUnitDtoFromJSON)),
        'availableValues': !exists(json, 'availableValues') ? undefined : (json['availableValues'] === null ? null : (json['availableValues'] as Array<any>).map(NumericValueWithUnitDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateNumericDataSetFilterDtoToJSON(value?: CreateNumericDataSetFilterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'dataTypeId': value.dataTypeId,
        'isEnabled': value.isEnabled,
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value.geometry),
        'selectedValues': value.selectedValues === undefined ? undefined : (value.selectedValues === null ? null : (value.selectedValues as Array<any>).map(NumericValueWithUnitDtoToJSON)),
        'availableValues': value.availableValues === undefined ? undefined : (value.availableValues === null ? null : (value.availableValues as Array<any>).map(NumericValueWithUnitDtoToJSON)),
        '$type': value.$type,
    });
}

